import { Box } from '@/shared/ui';

import type { SymbolKey } from '@/entities/symbol';
import CustomCheckbox from '@/shared/ui/primitives/Checkbox';

import { useSelectionFunctions } from '../hooks/useSelectionFunctions';

export const SymbolCheckbox = ({ symbol }: { symbol: SymbolKey }) => {
  const { isSymbolSelected, toggleSymbolInSelection, isSpotLocked } = useSelectionFunctions();
  return (
    <CustomCheckbox
      checked={isSymbolSelected(symbol)}
      modeLocked={isSpotLocked}
      onLockedClick={() => {
        toggleSymbolInSelection(symbol);
      }}
      onChange={() => {
        toggleSymbolInSelection(symbol);
      }}
    />
  );
};

export const SelectAllToggle = ({ symbols }: { symbols: SymbolKey[] }) => {
  const { areAllSymbolsSelected, addSymbolsToSelection, removeSymbolsFromSelection, isSpotLocked } =
    useSelectionFunctions();
  const allSelected = areAllSymbolsSelected(symbols);
  return (
    <Box
      aria-label='select all'
      role='button'
      tabIndex={0}
      sx={{
        color: isSpotLocked ? 'gx.textDisabled' : 'gx.highlight',
        fontSize: 10,
        cursor: isSpotLocked ? 'not-allowed' : 'pointer'
      }}
      onClick={() => {
        if (allSelected) {
          removeSymbolsFromSelection(symbols);
        } else {
          addSymbolsToSelection(symbols);
        }
      }}
    >
      {allSelected ? 'Deselect all' : 'Select all'}
    </Box>
  );
};
